import React, {Fragment} from "react";

const AngularBottomShell = () => {
    return <Fragment>
        <span>{"}"}</span>
        <span><span>{"}"}</span></span>
    </Fragment>
};

export default AngularBottomShell;